var Rebase = require('re-base');
var firebase = require('firebase/app');
require('firebase/firestore');
require('firebase/auth');
var app = firebase.initializeApp({
  apiKey: 'AIzaSyCahcaejBx56NpoYE3axP0CWkeGNZwwc_A',
  authDomain: 'domality-45640.firebaseapp.com',
  databaseURL: 'https://domality-45640.firebaseio.com',
  projectId: 'domality-45640',
  storageBucket: 'domality-45640.appspot.com',
  messagingSenderId: '788431002760'
});

var db = firebase.firestore(app);
var settings = { timestampsInSnapshots: true };
db.settings(settings);

export const base = Rebase.createClass(db);
export const auth = firebase.auth(app);



// WEBPACK FOOTER //
// ./src/base.js